import { useAuth } from "./useAuth";

const Authorization = ({ type, rolePermission, children }) => {
  const { user, logout } = useAuth();
  const { uiPermissions } = user;
  const session = JSON.parse(localStorage.getItem("session"));
  const token = session ? session.token : null;
  if (!token) {
    return logout("LOGOUT");
  }
  const localStoragePermission = session.isoAgent.uiPermissions ?? [];

  if (type === "accordion") {
    return rolePermission !== 0 ? children : null;
  }

  if (type === "page") {
    return rolePermission == "" ||
      uiPermissions.includes(rolePermission) ||
      localStoragePermission.includes(rolePermission)
      ? children
      : null;
  }
};

export default Authorization;
